import { QueryType } from 'dashboard/models/graph-query';
import {
  GraphQueryTemplate,
  GraphQueryTemplateStatus,
} from 'dashboard/models/graph-query-template';
import {
  GraphQueryTemplateAction,
  GraphQueryTemplateActionType,
} from 'dashboard/redux/actions/graph-query-template';
import { ApiModel } from 'lib/interfaces/api';

export interface GraphQueryTemplateState {
  graphQueryTemplate: GraphQueryTemplate;
}

export const mockGraphQueryTemplate: GraphQueryTemplate = {
  type: ApiModel.GraphQueryTemplate,
  id: 'gqt_1',
  attributes: {
    description: 'Find duplicate accounts',
    name: 'Duplicate Accounts',
    'updated-at': '2022-03-21T20:46:57-07:00',
    'environment-id': 'env_asdf',
    type: QueryType.ByAccount,
    payload: {
      type: QueryType.ByAccount,
      conditionals: [],
      variables: [],
      'known-node-ids': [],
      'node-limit': 100,
      'expandability-limit': 1000,
      'start-cursor': '',
    },
    'input-schema': {},
    status: GraphQueryTemplateStatus.Active,
  },
};

export const mockGraphQueryTemplateState: GraphQueryTemplateState = {
  graphQueryTemplate: mockGraphQueryTemplate,
};

const initialGraphQueryTemplateState: GraphQueryTemplateState = {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  graphQueryTemplate: null,
};

export default (
  state: GraphQueryTemplateState = initialGraphQueryTemplateState,
  action: GraphQueryTemplateAction,
) => {
  switch (action.type) {
    case GraphQueryTemplateActionType.Set: {
      return {
        ...state,
        graphQueryTemplate: action.payload.graphQueryTemplate,
      };
    }
    case GraphQueryTemplateActionType.Clear: {
      return {
        ...state,
        graphQueryTemplate: null,
      };
    }
    default:
      return state;
  }
};
